import { Box, Button, Text } from '@chakra-ui/react';

import { FilterIcon } from '@assets/icons/index';
import { ConditionalComponent } from '@components/functionComponent';

const FilterButton = ({ isOpen, onOpen, onClose, showIndicator = false, label = 'Filter' }) => {
    const handleClick = () => {
        if (isOpen) onClose?.();
        else onOpen?.();
    };

    return (
        <Button onClick={handleClick} variant={'secondary'} bg={isOpen || showIndicator ? 'semantic.200' : 'inherit'}>
            <FilterIcon />
            <Text>{label}</Text>

            <ConditionalComponent statement={showIndicator}>
                <Box p={'4px'} ms={'6px'} borderRadius={'full'} bg={'info.500'} />
            </ConditionalComponent>
        </Button>
    );
};

export default FilterButton;
